import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.provisionamiento.libre')
    },
    {
      id: 2,
      name: i18n.t('tipos.provisionamiento.bolsa')
    },
  ]
}

export function TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO (state) {
  return configHelper.getConfig(state, 'TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO', GenerateConfig)
}
